import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Search } from 'lucide-react';
import usePageTitle from '../hooks/usePageTitle';
import '../css/ProfileFavorites.css';
import { deleteFavorite, getUserFavorites } from '../helpers/favorites';
import { getCurrentUserData } from '../helpers/user';
import { API_BASE_URL } from '../helpers/api';

const ProfileFavorites = () => {
  usePageTitle('Mes Favoris');
  const [searchTerm, setSearchTerm] = useState('');
  const [favorites, setFavorites] = useState([]);
  // const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = await getCurrentUserData();
        // setUser(userData);
        
        if (userData?.id) {
          const userFavorites = await getUserFavorites(userData.id);
          // console.log(userFavorites)
          setFavorites(userFavorites);
        }
      } catch (err) {
        setError('Erreur lors du chargement des favoris');
        console.error('Error fetching data:', err);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);


  const filteredFavorites = favorites.filter(place =>
    place.establishment.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    place.establishment.category.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    place.establishment.tags.some(tag => tag.name.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleRemoveFavorite = async (favoriteId) => {
    try {
      const success = await deleteFavorite(favoriteId);
      if (success) {
        setFavorites(prevFavorites => 
          prevFavorites.filter(fav => fav.documentId !== favoriteId)
        );
        setSuccessMessage('Établissement retiré des favoris');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setError('Erreur lors de la suppression du favori');
        setTimeout(() => setError(null), 3000);
      }
    } catch (err) {
      setError('Erreur lors de la suppression du favori');
      setTimeout(() => setError(null), 3000);
      console.error('Error removing favorite:', err);
    }
  };

  if (isLoading) {
    return (
      <div className="favorites-page">
        <div className="favorites-header">
          <div className="container">
            <h1>Mes Favoris</h1>
            <p>Chargement de vos favoris...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="favorites-page">
      <div className="favorites-header">
        <div className="container">
          <h1>Mes Favoris</h1>
          <p>Retrouvez tous vos spots favoris au même endroit</p>
        </div>
      </div>

      <div className="container">
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        
        {successMessage && (
          <div className="alert alert-success" role="alert">
            {successMessage}
          </div>
        )}

        <div className="favorites-toolbar">
          <div className="search-box">
            <Search size={20} />
            <input
              type="text"
              placeholder="Rechercher dans vos favoris..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="favorites-count">
            {filteredFavorites.length} spot{filteredFavorites.length > 1 ? 's' : ''}
          </div>
        </div>

        {filteredFavorites.length > 0 ? (
          <div className="favorites-grid">
            {filteredFavorites.map((place) => (
              <div key={place.id} className="favorite-card">
                <Link to={`/spot/${place.establishment.documentId}`} className="card-image">
                  <img src={API_BASE_URL+place.establishment.images[0].url} alt={place.establishment.name} />
                  <span className="category-badge">{place.establishment.category.name}</span>
                </Link>
                <div className="card-content">
                  <Link to={`/spot/${place.establishment.documentId}`}>
                    <h3>{place.establishment.name}</h3>
                  </Link>
                  <div className="card-meta">
                    <div className="address">
                      <MapPin size={14} />
                      {place.establishment.address}, {place.establishment.postalCode} {place.establishment.city}
                    </div>
                  </div>
                  <div className="tags">
                    {place.establishment.tags.map((tag, index) => (
                      <span key={index} className="tag">{tag.name}</span>
                    ))}
                  </div>
                  <button 
                    className="remove-favorite"
                    onClick={() => handleRemoveFavorite(place.documentId)}
                  >
                    Retirer des favoris
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            {searchTerm ? (
              <>
                <p>Aucun favori ne correspond à votre recherche</p>
                <button 
                  className="clear-search"
                  onClick={() => setSearchTerm('')}
                >
                  Effacer la recherche
                </button>
              </>
            ) : (
              <>
                <p>Vous n'avez pas encore de favoris</p>
                <Link to="/les-spots" className="explore-link">
                  Explorer les spots
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileFavorites;